module.exports = __webpack_public_path__ + "img/pop_lu@2x.2a43db6b.png";